import FormLabel from '@mui/material/FormLabel';
import Slider from '@mui/material/Slider';
import { FormContextType, RJSFSchema, StrictRJSFSchema, WidgetProps, rangeSpec } from '@rjsf/utils';
import useLinkifiedLabel from './useLinkifiedLabel';

/** The `RangeWidget` component uses the `BaseInputTemplate` changing the type to `range` and wrapping the result
 * in a div, with the value along side it.
 *
 * @param props - The `WidgetProps` for this component
 */
export default function RangeWidget<T = any, S extends StrictRJSFSchema = RJSFSchema, F extends FormContextType = any>(props: WidgetProps<T, S, F>) {
  const { value, readonly, disabled, onBlur, onFocus, options, schema, onChange, required, label, id } = props;
  const sliderProps = { value, label, id, name: id, ...rangeSpec<S>(schema) };

  const _onChange = (_: any, val?: number | number[]) => {
    onChange(val ? val : options.emptyValue);
  };
  const _onBlur = ({ target: { value: val } }: React.FocusEvent<HTMLInputElement>) => onBlur(id, val);
  const _onFocus = ({ target: { value: val } }: React.FocusEvent<HTMLInputElement>) => onFocus(id, val);

  const displayLabel = useLinkifiedLabel(label);

  return (
    <>
      <FormLabel required={required} htmlFor={id}>
        {displayLabel || schema.title}
      </FormLabel>
      <Slider disabled={disabled || readonly} onChange={_onChange} onBlur={_onBlur} onFocus={_onFocus} valueLabelDisplay="auto" {...sliderProps} />
    </>
  );
}
